export enum SportInteractionTypeEnum {
	PrematchSport = "Prematch Sport",
	PrematchCategory = "Prematch Category",
	PrematchTournament = "Prematch Tournament",
	PrematchEvent = "Prematch Event",
	LiveSport = "Live Sport",
	LiveCategory = "Live Category",
	LiveTournament = "Live Tournament",
	LiveEvent = "Live Event",
	TopTournament = "Top Tournament",
	LiveMenuConfirm = "Live Betting Menu Confirm",
	PrematchMenuConfirm = "Prematch Betting Menu Confirm",
	PrematchTopTournamentTournament = "Prematch Top Tournament",
}
